import React, { useState, useEffect } from 'react';
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api';

import styles from './AddressForm.module.css';
import env from '../../../env';
import { Search } from '../../../components/Icon';

const libraries = ['places'];

const PlaceAutocomplete = ({ onUpdate, defaultValue }) => {
  const [autocomplete, setAutocomplete] = useState(null);
  const [value, setValue] = useState(defaultValue || '');

  const [formData, setFormData] = useState({
    name: '',
    street: '',
    streetnumber: '',
    postalcode: '',
    city: '',
    country: '',
    website: '',
    phonenumber: '',
    lat: '',
    lng: '',
  });

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: env.google_maps_api_key,
    libraries,
    language: 'en',
  });

  const handlePlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      const addressComponents = place.address_components || [];

      const newFormData = {
        name: place.name || '',
        street: addressComponents.find(comp => comp.types.includes('route'))?.long_name || '',
        streetnumber: addressComponents.find(comp => comp.types.includes('street_number'))?.long_name || '',
        postalcode: addressComponents.find(comp => comp.types.includes('postal_code'))?.long_name || '',
        city: addressComponents.find(comp => comp.types.includes('locality'))?.long_name || '',
        country: addressComponents.find(comp => comp.types.includes('country'))?.long_name || '',
        website: place.website || '',
        phonenumber: place.formatted_phone_number || '',
        lat: place.geometry?.location?.lat() || '',
        lng: place.geometry?.location?.lng() || '',
      };

      let label = '';
      ['name', 'street', 'city', 'country'].forEach((item, i) => {
        if (newFormData?.[item]) {
          label += newFormData?.[item];
          i < 3 ? (label += ', ') : (i += '');
        }
      });
      setValue(label);

      setFormData(newFormData);

      if (onUpdate) {
        onUpdate(newFormData);
      }
    }
  };

  const onLoad = autoC => {
    setAutocomplete(autoC);
  };

  const handleInputChange = e => {
    setValue(e.target.value);
  };

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  if (loadError) {
    return <p>Error loading Google Maps API</p>;
  }

  if (!isLoaded) {
    return <p>Loading...</p>;
  }

  return (
    <Autocomplete onLoad={onLoad} onPlaceChanged={handlePlaceChanged}>
      <div className="d-flex">
        <input
          type="text"
          className={`form-control fw-lighter ${styles.Input}`}
          placeholder="Zoeken..."
          value={value}
          onChange={handleInputChange}
        />
        <button className={`btn btn-outline-secondary ${styles.Button}`} type="button">
          <Search />
        </button>
      </div>
    </Autocomplete>
  );
};

export default PlaceAutocomplete;
